<app-default-layout [title]="'REGISTRIERUNG.PW_RESET'">
  <div class="row">
    <div class="col-md-8 offset-md-2">
      <form [formGroup]="pwZuruecksetzenForm" (ngSubmit)="this.save()" class="form-horizontal"
            accept-charset="UTF-8">

        <div class="flex-grow-1 mr-2 mb-3">
          {{'REGISTRIERUNG.INFO' | translate}}
        </div>

        <div class="form-group group-for-email col mb-3">
          <div class="d-flex flex-row">
            <div class="flex-grow-1 mr-2">
              <app-custom-input id="email" type="text"
                                class="flex-grow-1"
                                label="{{'REGISTRIERUNG.MAIL' |translate }}"
                                [customFormGroup]="pwZuruecksetzenForm"
              ></app-custom-input>
            </div>
          </div>
        </div>
        <div class="d-flex flex-column">
          <button type="submit" class="btn btn-primary btn-block" data-cy="btn-submit">{{'REGISTRIERUNG.SAVE-BTN' | translate}}</button>
        </div>
      </form>
    </div>
  </div>
</app-default-layout>
